<template>
  <el-dialog
    title="资料打印"
    :visible.sync="visible"
    append-to-body
    @close="close()"
    width="30%">
    <el-form ref="ruleForm" class="orgForm">
        <el-table
          ref="multipleTable"
          :data="notaryFileList"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
              type="selection"
              width="55"
              label="">
            </el-table-column>
            <el-table-column
              prop="name"
              width="120"
              label="材料列表">
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="创建时间"
              show-overflow-tooltip>
            </el-table-column>
        </el-table>

      <el-form-item>
        <el-button size="small" type="primary" @click="prints()">打印</el-button>
        <el-button size="small"  @click="close()">取消</el-button>
      </el-form-item>
     </el-form>
    </el-dialog>
</template>

<script>
export default {
    data() {
        return {
            notaryFileList: [],//材料列表
            notaryDocumentList: [], //证据材料列表
            notaryZhixing: [], //执行材料列表
            visible: false,
            multipleSelection: [],//选中的材料列表
            pathList:[],
            base64: '',
        }
    }, 
    methods: {
        //点击保存按钮执行的事件
        handleSelectionChange(val) {
            this.multipleSelection =val; //获取选中的材料
            this.pathList = [];
            this.multipleSelection.forEach(item =>{
                this.pathList.push(item.path)
            });
        },
        open(notaryDocumentList){
            // this.getPrinterList();
            this.visible = true;
            this.notaryFileList = notaryDocumentList;
            
            this.$nextTick(() => {
                this.notaryFileList.forEach(item =>{
                    if(item.type == 0 || item.type == 3 ||
                       item.type == 7 || item.type == 9 ||
                       item.type == 10 || item.type == 11 ||
                       item.type == 14 || item.type == 15){
                        this.multipleSelection.push(item)
                        this.$refs.multipleTable.toggleRowSelection(item,true)
                    }
                })
                console.log("证据材料列表为:",this.notaryFileList);
                console.log("选中的材料列表为:",this.multipleSelection);
            })

            
            
        },
        close(){
            this.multipleSelection = [];
            this.visible = false;
        },
        //打印功能
        // prints(){
        //     this.pathList.forEach(item => {
        //         this.handleBefore(item);
        //     });
        //     if(this.printer == ''){
        //         this.$alert('请选择打印机', '提示', {
        //             confirmButtonText: '确定',
        //         });
        //     }else if(this.pathList.length == 0){
        //         this.$alert('请选择材料！', '提示', {
        //             confirmButtonText: '确定',
        //         });
        //     }else{
        //         this.$api.printFile({
        //             printer: this.printer,
        //             pathList: this.pathList
        //         }).then(res => {
        //             if (res.data.code === '200') {
        //                 console.log('res',res)
        //                 this.$message({
        //                     type: 'success',
        //                     message: '打印成功',
        //                 })
        //             } else {
        //                 this.$message({
        //                     type: 'error',
        //                     message: res.data.data,
        //                 })
        //             }
        //         })
        //     }
        // },

        //新打印功能
        prints(){
            this.pathList.forEach(item => {
                this.handleBefore(item);
            });
            if(this.pathList.length == 0){
                this.$alert('请选择材料！', '提示', {
                    confirmButtonText: '确定',
                });
            }else{
                this.$api.printFile({
                    pathList: this.pathList
                }).then(res => {
                    if (res.data.code === '200') {
                        // console.log('res',res.data.data)
                        this.base64 = res.data.data
                        let blob = this.dataURLtoBlob(this.base64);
                        var date = (new Date()).getTime()
                        var ifr = document.createElement('iframe')
                        ifr.style.frameborder = 'no'
                        ifr.style.display = 'none'
                        ifr.style.pageBreakBefore = 'always'
                        ifr.setAttribute('id', 'printPdf'+ date)
                        ifr.setAttribute('name', 'printPdf'+ date)
                        ifr.src = window.URL.createObjectURL(blob)
                        document.body.appendChild(ifr)
                        this.doPrint('printPdf'+ date)
                        window.URL.revokeObjectURL(ifr.src) // 释放URL 对象
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.data,
                        })
                    }
                })
            }
        },
        //检验选取材料是否为JPG、PNG、PDF
        handleBefore(fileName) {
            var FileExt = fileName.replace(/.+\./, '')
            if (['jpg', 'png', 'pdf','jpge'].indexOf(FileExt.toLowerCase()) === -1) {
                this.$refs.multipleTable.clearSelection();
                return false;
            }
        },

        //将后台传过来的base64转成文件流
        dataURLtoBlob (dataurl) {
            var bstr = atob(dataurl);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], { type: 'application/pdf' });
        },

        doPrint(val) {
            var ordonnance = document.getElementById(val).contentWindow;
            setTimeout(() => {
                ordonnance.print();
                // this.pdfLoading = false;
            }, 100);
        },

    }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 12px;
}
</style>